import { Inbound } from '@domain/purchasing/models/Inbound';
import { InboundDTO } from '../dto/InboundDTO';

export class InboundMapper {
  static toModel(dto: InboundDTO): Inbound {
    return {
      quantity: dto.quantity,
      date: new Date(dto.date),
      purchaseOrderId: dto.purchaseOrderId,
    };
  }

  static toDTO(model: Inbound): InboundDTO {
    return {
      quantity: model.quantity,
      date: model.date.toISOString(),
      purchaseOrderId: model.purchaseOrderId,
    };
  }
}
